
import { SelectImageComp } from "../molecule/selectImageComp"

import { HorizontalLayout } from "./layout"

import {  ImageSelectorModalCopy } from "./customModals"


import { PublishActionComp } from './publishActionComp'

export default function PublishCourseComp({ courseData, activeModal,selectImage, openSelector, description, loadCourse, CustomerStage}) {
  return (
    <HorizontalLayout className="publish-course-comp">
        <SelectImageComp
            description={description}
            courseData={courseData}
            title={courseData.title}
            disabled={courseData.published === 1 ? true : false}
            url={courseData?.image_url}
            openSelector={openSelector}
        /> 
        <ImageSelectorModalCopy
          visible={activeModal}
          imageSelected={selectImage}
          dismiss={openSelector}
        />
        <PublishActionComp CustomerStage={CustomerStage} data={courseData} loadCourse={loadCourse}/>
    </HorizontalLayout>
   )

  
}



